export default {"src":"/_next/static/media/location-pin-new.78e6c83f.svg","height":20,"width":18};